import React from 'react';
import { Box, Container, Tabs, Tab, Typography, CircularProgress } from "@mui/material";
import ListAltIcon from '@mui/icons-material/ListAlt';
import CancelIcon from '@mui/icons-material/Cancel';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import FingerprintIcon from '@mui/icons-material/Fingerprint';
import { getUserName, httpClient } from 'Service/Service';
import DataGrid from 'components/table/DataGrid';
import { PRIMARY } from 'themes/colors';

// ----------------------------------------------------------------------

const tabs = [
    { label: 'Complete List',           icon: <ListAltIcon fontSize="small" /> },
    { label: 'Rejected List',           icon: <CancelIcon fontSize="small" /> },
    { label: 'SV Ready List',           icon: <VerifiedUserIcon fontSize="small" /> },
    { label: 'Pending Fingerprint',     icon: <FingerprintIcon fontSize="small" /> },
];

const columns = [
    { title: "Name",                    field: "name" },
    { title: "Main Aadhaar",            field: "mainAadhaar" },
    { title: "Family Aadhaar",          field: "familyAadhaar" },
    { title: "Mobile",                  field: "mobile" },
    { title: "Contact Number",          field: "contactNumber" },
    { title: "Registered Agency",       field: "registeredAgencyName" },
    { title: "Installation Status",     field: "installtatus" },
    { title: "Agent Name",              field: "mainAgent" },
    { title: "Remarks",                 field: "remarks" },
];

// ----------------------------------------------------------------------

const AgentView = () => {
    const [consumerList, setConsumerList] = React.useState([]);
    const [value, setValue] = React.useState(0);
    const [loading, setLoading] = React.useState(false);

    React.useEffect(() => {
        document.title = "Agent View | Jaman HP Gas";
        fetchTabData(value);
    }, [value]);

    const handleChangevalue = (_: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    const fetchTabData = async (tabIndex: number) => {
        setLoading(true);
        try {
            let result;
            switch (tabIndex) {
                case 0:
                    result = await httpClient("agent/fingerprint", "POST", {
                        findKey: "pending",
                        mainAgent: getUserName(),
                    });
                    break;
                case 1:
                    result = await httpClient("agent/fingerprint", "POST", {
                        findKey: "reject",
                        mainAgent: getUserName(),
                    });
                    break;
                case 2:
                    result = await httpClient("agent/svreadylist", "POST", {
                        mainAgent: getUserName(),
                    });
                    break;
                case 3:
                    result = await httpClient("agent/fingerprint", "POST", {
                        findKey: "pending",
                        mainAgent: getUserName(),
                    });
                    break;
                default:
                    break;
            }
            if (result?.data) setConsumerList(result.data);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box sx={{ minHeight: '100vh', bgcolor: 'grey.100', pb: 4 }}>

            {/* Page Header */}
            <Box
                sx={{
                    background: `linear-gradient(135deg, ${PRIMARY.darker} 0%, ${PRIMARY.dark} 50%, ${PRIMARY.main} 100%)`,
                    color: 'white',
                    px: { xs: 2.5, sm: 4 },
                    py: { xs: 3, sm: 4 },
                }}
            >
                <Typography variant="h5" fontWeight={700} lineHeight={1.2}>
                    Agent View
                </Typography>
                <Typography variant="body2" sx={{ opacity: 0.75, mt: 0.5 }}>
                    Browse consumer lists by category
                </Typography>
            </Box>

            {/* Sticky Tab Bar */}
            <Box
                sx={{
                    bgcolor: 'background.paper',
                    borderBottom: '1px solid',
                    borderColor: 'divider',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                    position: 'sticky',
                    top: 0,
                    zIndex: 10,
                }}
            >
                <Tabs
                    value={value}
                    onChange={handleChangevalue}
                    variant="scrollable"
                    scrollButtons="auto"
                    sx={{
                        px: { xs: 1, sm: 3 },
                        '& .MuiTabs-indicator': {
                            bgcolor: 'primary.main',
                            height: 3,
                            borderRadius: '3px 3px 0 0',
                        },
                    }}
                >
                    {tabs.map((tab, idx) => (
                        <Tab
                            key={tab.label}
                            label={tab.label}
                            icon={tab.icon}
                            iconPosition="start"
                            sx={{
                                fontWeight: 600,
                                fontSize: { xs: 12, sm: 13 },
                                minHeight: 52,
                                textTransform: 'none',
                                color: 'text.secondary',
                                '&.Mui-selected': { color: 'primary.main' },
                            }}
                        />
                    ))}
                </Tabs>
            </Box>

            {/* Content */}
            <Container maxWidth="xl" sx={{ pt: 3 }}>
                {loading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 300 }}>
                        <CircularProgress size={48} thickness={4} />
                    </Box>
                ) : (
                    <DataGrid
                        title={tabs[value]?.label}
                        rows={consumerList}
                        columns={columns}
                    />
                )}
            </Container>
        </Box>
    );
};

export default AgentView;
